var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/baseconeproduct/viewmodels/index',["require", "exports", "common/viewmodelbase", "models/portal", "services/navigator", "services/settings"], function (require, exports, Common, Portal, Navigator, Configuration) {
    "use strict";
    var BaseconeProductViewModel = (function (_super) {
        __extends(BaseconeProductViewModel, _super);
        function BaseconeProductViewModel() {
            _super.call(this);
            this.breadCrumb = new Portal.ModuleBreadCrumbItemHolder();
            this.cdnEndPoint = Configuration.Settings.environment.getCustomValue("CdnEndPoint");
            this.testimonials = [];
            this.toolkits = [];
            this.informationToSendToClient = [];
            this.initializeTestimonials();
            this.initializeToolkits();
            this.initializeInformationToSendToClient();
            this.title = "BaseconeProduct";
            ko.track(this, ["tabSelected", "testimonials"]);
        }
        BaseconeProductViewModel.prototype.onActivated = function (context) {
            this.tabSelected = 0;
            this.shopId = context.queryString.shopId;
            var parameter = context.path.split('/');
            var calledFromTools = parameter[1] != null ? JSON.parse(parameter[1]) : null;
            this.createBaseconeCrumb();
            this.spliceLastBreadcrumbs(context, calledFromTools);
            this.getBaseconeProductDetails();
            this.createBaseconeProductDetailsCrumb();
        };
        BaseconeProductViewModel.prototype.initializeTestimonials = function () {
            var testimonial1 = {
                image: this.cdnEndPoint + "content/images/4pointzero_logo.jpg",
                text: '"Basecone is a key part of our online solution and has helped us and our clients to become completely paperless in our accounting and advisory processes. We have worked with Basecone since 2014 and during this time we have been continually impressed by their ability to innovate and improve the efficiency of our relationship with our clients and how we handle their documents securely."',
                name: "Jamie Allen, Managing Partner, 4PointZero",
                link: "",
                customCss: "basecone-product-testimonial-logo-image-large"
            };
            var testimonial2 = {
                image: this.cdnEndPoint + "content/images/TangmereLogo.png",
                text: '“We were looking for document management with a simple approval process for people in different locations, wanting to do things at different times of the day, and Basecone was perfect for that.  Basecone flux enables me to approve all my purchase invoices and be productive in places and periods where I would otherwise not have been productive – such as when travelling to meetings.  And for other users who are deskbound, the online portal works really well.  The training required to get up and running was minimal.  Within five minutes you are an expert.  When you are dealing with non-Accountant type users, the user experience is especially important and Basecone just makes it as simple as possible.”',
                name: "Robert Searle, Finance Director, Tangmere Airfield Nurseries",
                link: "",
                customCss: "basecone-product-testimonial-logo-image-large"
            };
            var testimonial3 = {
                image: this.cdnEndPoint + "content/images/JKSLogo.png",
                text: '“Basecone is such a helpful tool for us to manage all our invoices, statements & supplier correspondence in one place.  The authorisation process is simple and suited to multi-site businesses allowing us to get approval even when approvers are not in the office.  The link to Twinfield speeds up our internal processes greatly.”',
                name: "Amy Lye, Group Financial Controller, JKS Restaurants",
                link: "",
                customCss: "basecone-product-testimonial-logo-image-small"
            };
            var testimonial4 = {
                image: this.cdnEndPoint + "content/images/agsLogo.jpg",
                text: '"Having the Basecone scanned images available in Twinfield enables both us, and the clients who have direct access to Twinfield, to quickly and easily drill down from reports directly to the source documents underlying any value in any report.  This feature increases the efficiency and effectiveness of communication with our clients and is therefore a key a benefit to us."',
                name: "Steve Aston FCCA, Director, ags accountants and business advisors ltd",
                link: "",
                customCss: "basecone-product-testimonial-logo-image-large"
            };
            this.testimonials.push(testimonial1);
            this.testimonials.push(testimonial2);
            this.testimonials.push(testimonial3);
            this.testimonials.push(testimonial4);
        };
        BaseconeProductViewModel.prototype.initializeToolkits = function () {
            var toolkit1 = {
                url: "https://www.basecone.com/en/",
                text: 'Basecone for accountants ›',
                icon: "fa-external-link"
            };
            var toolkit2 = {
                url: "https://www.basecone.com/en/spenser/",
                text: 'Claim your expenses on the go! Basecone SPENSER ›',
                icon: "fa-external-link"
            };
            var toolkit3 = {
                url: "https://www.basecone.com/en/flux/",
                text: 'Authorise documents with just one swipe! Basecone FLUX ›',
                icon: "fa-external-link"
            };
            var toolkit4 = {
                url: "https://www.basecone.com/en/pricing/",
                text: 'Pricing information ›',
                icon: "fa-external-link"
            };
            this.toolkits.push(toolkit1);
            this.toolkits.push(toolkit2);
            this.toolkits.push(toolkit3);
            this.toolkits.push(toolkit4);
        };
        BaseconeProductViewModel.prototype.initializeInformationToSendToClient = function () {
            var informationToSendToClient1 = {
                url: "https://ocuksbstatic.blob.core.windows.net/iserve/WK-Basecone-Brochure-SMEs.pdf",
                text: "WK Basecone Brochure SME's",
                icon: "fa-file-text-o"
            };
            this.informationToSendToClient.push(informationToSendToClient1);
        };
        BaseconeProductViewModel.prototype.createBaseconeCrumb = function () {
            // initial add of Basecone breadcrumb
            if (this.breadCrumb.items.length === 0) {
                this.addBaseconeCrumbToBreadcrumbItems();
            }
        };
        BaseconeProductViewModel.prototype.spliceLastBreadcrumbs = function (context, calledFromTools) {
            // calledFromTools - flag to see where BaseconeProduct is called from (null - called from Dashboard, not null - called from Tools)
            if (this.breadCrumb.items.length > 1) {
                // for the Basecone page in Tools
                if (calledFromTools == true) {
                    this.breadCrumb.items.splice(this.breadCrumb.items.length - 1, 1);
                }
                else {
                    this.breadCrumb.items.splice(this.breadCrumb.items.length - 2, 2);
                }
            }
            else {
                // for the Basecone page in Tools
                if (calledFromTools == true) {
                    this.breadCrumb.items.splice(this.breadCrumb.items.length - 1, 1);
                    this.addBaseconeCrumbToBreadcrumbItems();
                }
                else {
                    this.breadCrumb.items.splice(this.breadCrumb.items.length - 1, 1);
                }
            }
        };
        BaseconeProductViewModel.prototype.addBaseconeCrumbToBreadcrumbItems = function () {
            var crumb = Portal.BreadCrumbItem.from("i-Serve");
            crumb.clickAction = function () { Navigator.navigateTo("iServe", "index", "/iServe", null); };
            this.breadCrumb.items.push(crumb);
        };
        BaseconeProductViewModel.prototype.getBaseconeProductDetails = function () {
            this.node = Portal.Context.shell.findNodeByUID(this.shopId);
        };
        BaseconeProductViewModel.prototype.createBaseconeProductDetailsCrumb = function () {
            var crumb = Portal.BreadCrumbItem.from(this.node.name);
            this.breadCrumb.items.push(crumb);
        };
        BaseconeProductViewModel.prototype.selectTab = function (index) {
            this.tabSelected = index;
        };
        return BaseconeProductViewModel;
    }(Common.ViewModelBase));
    var instance = new BaseconeProductViewModel();
    return instance;
});

